<template>
  <div id="app">
    <keep-alive>
      <VHeader v-if="!mobile()"></VHeader>
    </keep-alive>
    <keep-alive>
      <VMobileHeader></VMobileHeader>
    </keep-alive>
    <keep-alive>
      <router-view ref="minHeight"></router-view>
    </keep-alive>
    <keep-alive>
      <VFooter ref="footer"/>
    </keep-alive>
    <v-return-top/>
    <v-loading :hidden=h></v-loading>
  </div>
</template>

<script>
  import VHeader from 'components/VHeader'
  import VFooter from 'components/VFooter'
  import VMobileHeader from 'components/VMobileHeader'
  import VReturnTop from 'components/VReturnTop'
  import VLoading from 'components/VLoading'

  export default {
    name: 'App',
    components: {VHeader, VFooter, VReturnTop, VMobileHeader, VLoading},
    data() {
      return {
        h: false
      }
    },
    mounted() {
      setTimeout(() => {
        this.loadingHide();
      },2000)
    },
    watch: {
      $route() {
        this.$nextTick(() => {
          this.setMinHeight();
        })
      }
    },
    methods: {
      setMinHeight() {
        this.$refs.minHeight.$el.style.minHeight = (document.documentElement.clientHeight - this.$refs.footer.$el.clientHeight) + 'px';
      },
      loadingHide() {
        this.h = true;
      }
    }
  }
</script>
<style lang="scss" scoped>
  #app {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -2;
    /*background: url(./assets/bj.jpg) repeat;*/
    background-color: #bbb090;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue